import React from "react";
import { Link } from "react-router-dom";
import { BLOGS } from "./blogsData";

const Blogs = () => {
  return (
    <section className="bg-gray-900 text-white">
      <header className="text-center pt-20 pb-12">
        <h1 className="text-6xl md:text-9xl font-bold font-modum text-brand">
          BLOGS
        </h1>
      </header>
      <div className="py-16 px-6">
        <div className="max-w-6xl mx-auto text-center mb-14">
          <p className="text-gray-300 text-sm md:text-base">
            Insights, updates, and stories from Al Noor EdTech — exploring
            education, innovation, and impact.
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
          {BLOGS.map((blog) => (
            <Link
              key={blog.slug}
              to={`/blog/${blog.slug}`}
              className="bg-gray-800 rounded-xl overflow-hidden shadow-lg hover:shadow-brand/20 hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              <img
                src={blog.image}
                alt={blog.imageAlt}
                loading="lazy"
                className="w-full h-56 object-cover"
              />

              <div className="p-6 flex flex-col flex-1">
                <p className="text-sm text-brand mb-2">{blog.date}</p>
                <h2 className="text-xl font-semibold mb-3">{blog.title}</h2>
                <p className="text-gray-400 text-sm mb-4 flex-1">
                  {blog.excerpt}
                </p>

                <span className="text-brand font-medium text-sm">
                  Read article →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blogs;
